import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Pass-through interceptor.
 * Date/time conversion to KSA (UTC+3) is done by the API
 * (FlexibleDateTimeJsonConverter → +03:00). Do not shift again here.
 */
@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request);
  }
}
